export default __webpack_public_path__ + "static/media/idg.db2917f6.jpg";